
export default function BlogSection() {
  const blogPosts = [
    {
      id: 1,
      title: 'Training Tips',
      excerpt: 'Essential tips for new pilots starting their aviation journey in Central Texas. Learn the fundamentals that will make your flight training more effective.',
      category: 'Training',
      readTime: '5 min read',
      image: 'https://readdy.ai/api/search-image?query=Flight%20instructor%20teaching%20student%20pilot%20in%20cockpit%2C%20aviation%20training%20tips%2C%20professional%20flight%20instruction%2C%20pilot%20education%2C%20hands-on%20learning%2C%20aircraft%20controls%2C%20flight%20training%20guidance&width=400&height=250&seq=training-tips&orientation=landscape',
      link: '/blog/training-tips'
    },
    {
      id: 2,
      title: 'Weather',
      excerpt: 'Understanding Central Texas weather patterns for safe flying. Learn to read conditions and make informed decisions for your flights.',
      category: 'Safety',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=Aviation%20weather%20monitoring%2C%20pilot%20checking%20weather%20conditions%2C%20flight%20planning%2C%20meteorology%20for%20pilots%2C%20safe%20flying%20conditions%2C%20weather%20radar%2C%20aviation%20safety%20preparation&width=400&height=250&seq=weather-safety&orientation=landscape',
      link: '/blog/weather'
    },
    {
      id: 3,
      title: 'Career',
      excerpt: 'Exploring aviation career paths and opportunities. From recreational flying to professional aviation, discover your next steps in the industry.',
      category: 'Career',
      readTime: '6 min read',
      image: 'https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/04f90c95b5dc51f3ecd0394a3d62ef6f.jpeg',
      link: '/blog/career'
    }
  ];

  return (
    <section id="blog" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
            Aviation Insights & Tips
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay informed with the latest aviation knowledge, training tips, and industry insights from our experienced instructors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100">
              <div className="relative">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {post.category}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-teal-600 transition-colors cursor-pointer">
                  <a href={post.link} className="text-teal-600">
                    {post.title}
                  </a>
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">{post.readTime}</span>
                  <a 
                    href={post.link} 
                    className="text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer"
                  >
                    Read More →
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="/blog" 
            className="inline-flex items-center bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}